import { render, staticRenderFns } from "./PhotoUploader.vue?vue&type=template&id=4e777f10&scoped=true"
import script from "./PhotoUploader.vue?vue&type=script&lang=js"
export * from "./PhotoUploader.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploader.vue?vue&type=style&index=0&id=4e777f10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e777f10",
  null
  
)

export default component.exports